const fetchOptions = {
	headers: {
		'X-ARD-User-Agent': `ARD Web/${VERSION}`,
	},
};

export default fetchOptions;
